export default __webpack_public_path__ + "static/media/face.62c326ac.svg";